// extracted by mini-css-extract-plugin
export default {"mainContainer":"WebOnly_mainContainer__3uiyH","mainText":"WebOnly_mainText__aBrcS"};